import type { MouseEvent } from "react";
import { useCallback } from "react";

import type { DirectionalIconComponent } from "@jti/brand-icons";
import { Icon, IconButton } from "@jti/core-components";

export type InputIconProps = {
  icon: DirectionalIconComponent;
  isSuccess?: boolean;
  isDisabled?: boolean;
  label?: string;
  onClick?: () => void;
  dataTestId?: string;
};

/**
 * Icon rendered inside the `elemBefore` / `elemAfter` slot of `TextInput`.
 */
export const InputIcon = ({ icon, label, onClick, dataTestId }: InputIconProps) => {
  const preventFocusLoss = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  }, []);

  if (onClick) {
    return (
      <IconButton
        icon={icon}
        onClick={onClick}
        onMouseDown={preventFocusLoss}
        data-testid={dataTestId}
        aria-label={label}
      />
    );
  }
  return <Icon icon={icon} data-testid={dataTestId} />;
};
